<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="modal fade" id="costumModalresume" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Berita
                        </span>
                        <span v-else>
                            News
                        </span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="height: auto;min-width: 90vw; min-height: 98%;">
                    <div class="col-sm-12">
                        <img class="modal-content" id="img01">
                        <div id="caption"></div>
                    </div>
                </div>
                <div class="modal-footer text-center">
                    <div class="col-sm-12 text-center">
                        <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                            data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodalresume()">
                            <b>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    Tutup
                                </span>
                                <span v-else>
                                    Close
                                </span>
                            </b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="myModal" class="modal">
        <span class="close">&times;</span>
        <img class="modal-content" id="img01">
        <div id="caption"></div>
    </div>
    <div class="container-fluid bg-breadcrumb" style="height: 350px !important;">
        <div class="container text-center" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">BERITA</span>
                <span v-else>News</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-warning">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Berita</span>
                    <span v-else>News</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <div class="container-fluid blog py-5">
        <div class="container py-5">
            <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        Berita Terbaru
                    </h1>
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                        News Update
                    </h1>
                </div>
                <p class="mb-0" v-if="(bahasa === null) || (bahasa == 'ina')">
                    Berisikan berita, informasi dan kegiatan terbaru
                </p>
                <p class="mb-0" v-else>
                    Contains the latest news, information and activities
                </p>
            </div>
            <div class="row g-4 justify-content-center">
                <div class="col-sm-12 float-left pb-2 px-3 wow fadeInDown">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Jumlah Data Berita:</span> <span v-else>Number
                        of News Data:</span> {{ G_numFormat(jumlahdata) }}
                    <span style="float: right;">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Halaman ke: </span> <span v-else>Page no:
                        </span><select v-model="halaman" @change="onChangeHalaman($event)">
                            <option v-for="index in jumlahhalaman" :key="index">
                                {{ index }}</option>
                        </select> <span v-if="(bahasa === null) || (bahasa == 'ina')"> dari </span> <span v-else> from
                        </span> {{ jumlahhalaman }}
                    </span>
                </div>
                <div class="col-sm-11 float-left wow fadeInDown">
                    <input type="text" v-model="carikata" class="form-control form-control-sm"
                        placeholder="Masukkan Kata Kunci Pencarian / Enter Search Keywords">
                </div>
                <div class="col-sm-1 float-left wow fadeInDown">
                    <button type="button" class="btn btn-success3 btn-sm text-white" @click="caridata()"
                        data-toggle="tooltip" data-placement="left" title="Cari data..">
                        <i class="fas fa-search"></i>
                    </button>
                </div>
                <div class="col-md-3 col-lg-3 col-xl-3 wow fadeInUp" data-wow-delay="0.1s"
                    style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;"
                    v-for="(beranda, urutberanda) in databeranda" :key="urutberanda">
                    <div class="blog-item rounded">
                        <div class="blog-img gmbpmis">
                            <img v-if="(bahasa === null) || (bahasa == 'ina')" :id="beranda.id"
                                :src="folder_foto + beranda.filenya_berita" class="img-fluid w-100"
                                :alt="beranda.kontenfull" @click="ambilgambar(beranda.id)"
                                style="max-height: 200px;min-height: 200px;">
                            <img v-else :id="beranda.id" :src="folder_foto + beranda.filenya_berita"
                                class="img-fluid w-100" :alt="beranda.konten_eng_full" @click="ambilgambar(beranda.id)"
                                style="max-height: 200px;min-height: 200px;">
                        </div>
                        <div class="p-4" style="min-height: 370px !important;border-left: solid 1px #005c95 !important;border-right: solid 1px #005c95 !important;">
                            <div class="d-flex justify-content-between mb-4" style="font-size: 10px;">
                                <p class="mb-0 text-muted">
                                    <i class="fa fa-calendar-alt text-primary"></i>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        {{ G_formatDate(beranda.tanggal) }}
                                    </span>
                                    <span v-else>
                                        {{ G_formatDateEng(beranda.tanggal) }}
                                    </span>
                                </p>
                            </div>
                            <a href="javascript:void(0)" class="pmisjudulberita" @click="ambilgambar(beranda.id)">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    {{ beranda.nama }}
                                </span>
                                <span v-else>
                                    {{ beranda.nama_eng }}
                                </span>
                            </a>
                            <p style="font-size: 8px !important;">
                                <span style="font-size: 8px !important;">
                                </span>
                            </p>
                            <p v-if="(bahasa === null) || (bahasa == 'ina')">
                                <span v-html="beranda.konten"></span>
                            </p>
                            <p v-else>
                                <span v-html="beranda.konten_eng"></span>
                            </p>
                        </div>
                        <div class="text-center" style="min-height: 20px !important;background-color: #005c95;">
                            <a href="javascript:void(0)" class="btn rounded-pill text-white py-2 px-4 mb-1"
                                @click="ambilgambar(beranda.id)">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    Selengkapnya
                                </span>
                                <span v-else>
                                    Read more
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, Carousel, Slide, Pagination, Navigation,
    },
    data() {
        return {
            halamanloading: true,
            bahasa: localStorage.getItem("bahasasistem"),
            tabaktif: encodeURIComponent(CryptoJS.AES.encrypt('', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            datapesan: '',
            carikata: '',
            datamaster: [],
            tahun: new Date().getFullYear(),
            slides: [],
            breakpoints: {
                // 700px and up
                700: {
                    itemsToShow: 1,
                    snapAlign: 'center',
                },
                // 1024 and up
                1024: {
                    itemsToShow: 1,
                    snapAlign: 'start',
                },
            },
            bahasa: localStorage.getItem("bahasasistem"),
            databeranda: [],
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_berita-Gambar?f=',
            jumlahdata: 0,
            jumlahhalaman: 0,
            mulai: 0,
            halaman: 1,
            project_id: process.env.VUE_APP_PROJECT_ID,
        };
    },
    methods: {
        tutupmodalresume() {
            $('#costumModalresume').modal('hide');
        },
        ambilgambar(id) {
            var modal = document.getElementById("costumModalresume");
            // Get the image and insert it inside the modal - use its "alt" text as a caption
            var img = document.getElementById(id);
            var modalImg = document.getElementById("img01");
            var captionText = document.getElementById("caption");
            //modal.style.display = "block";
            modalImg.src = img.src;
            captionText.innerHTML = img.alt;

            $('#costumModalresume').modal('show');
        },
        async caridata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            //alert(this.carikata);
            this.halamanloading = true;
            var random = Math.random();
            await mainAPI.get("parastapainnovation-GetBerita?random=" + random + "&nama=" + this.carikata + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        var datasementara = [];
                        this.databeranda = [];
                        datasementara = Response.data.content.data;
                        datasementara.forEach((item) => {
                            this.databeranda.push({
                                id: item.id,
                                nama: item.nama,
                                tanggal: item.tanggal,
                                nama_eng: item.nama_eng,
                                konten: (item.isi).substring(0, 100) + '...',
                                konten_eng: (item.isi_eng).substring(0, 100) + '...',
                                kontenfull: this.G_formatDate(item.tanggal) + item.isi + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>',
                                konten_eng_full: this.G_formatDateEng(item.tanggal) + item.isi_eng + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>',
                                filenya_berita: item.filenya_berita,
                            });
                        });
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                    }
                    else {
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                this.datamaster = [];
                this.slides = [];
                console.log(error);
                this.halamanloading = false;
            });
        },
        onChangeHalaman(event) {
            this.pindahhalaman(event.target.value);
        },
        async pindahhalaman(halamannya) {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

            this.halamanloading = true;
            var random = Math.random();
            await mainAPI.get("parastapainnovation-GetBerita?random=" + random + "&halaman=" + halamannya + "&nama=" + this.carikata + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        var datasementara = [];
                        this.databeranda = [];
                        datasementara = Response.data.content.data;
                        datasementara.forEach((item) => {
                            this.databeranda.push({
                                id: item.id,
                                nama: item.nama,
                                tanggal: item.tanggal,
                                nama_eng: item.nama_eng,
                                konten: (item.isi).substring(0, 100) + '...',
                                konten_eng: (item.isi_eng).substring(0, 100) + '...',
                                kontenfull: this.G_formatDate(item.tanggal) + item.isi + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>',
                                konten_eng_full: this.G_formatDateEng(item.tanggal) + item.isi_eng + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>',
                                filenya_berita: item.filenya_berita,
                            });
                        });
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                    }
                    else {
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                this.datamaster = [];
                this.slides = [];
                console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

            this.halamanloading = true;
            var random = Math.random();
            await mainAPI.get("parastapainnovation-GetBerita?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        var datasementara = [];
                        this.databeranda = [];
                        datasementara = Response.data.content.data;
                        datasementara.forEach((item) => {
                            this.databeranda.push({
                                id: item.id,
                                nama: item.nama,
                                tanggal: item.tanggal,
                                nama_eng: item.nama_eng,
                                konten: (item.isi).substring(0, 100) + '...',
                                konten_eng: (item.isi_eng).substring(0, 100) + '...',
                                kontenfull: this.G_formatDate(item.tanggal) + item.isi + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>',
                                konten_eng_full: this.G_formatDateEng(item.tanggal) + item.isi_eng + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>',
                                filenya_berita: item.filenya_berita,
                            });
                        });
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                    }
                    else {
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                this.datamaster = [];
                this.slides = [];
                //console.log(error);
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style>
/* The Modal (background) */
.modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 888888;
    /* Sit on top */
    padding-top: 20px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(251, 248, 248, 0.9);
    /* Fallback color */
    background-color: rgb(251, 248, 248, 0.9);
    /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    float: left;
    margin-right: 10px;
    margin-left: 60px;
}

/* Caption of Modal Image */
#caption {
    margin: auto;
    display: block;
    width: 90%;
    max-width: 90%;
    text-align: justify;
    color: #111;
    padding: 10px 0;
}

/* Add Animation */
.modal-content,
#caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
    from {
        -webkit-transform: scale(0)
    }

    to {
        -webkit-transform: scale(1)
    }
}

@keyframes zoom {
    from {
        transform: scale(0)
    }

    to {
        transform: scale(1)
    }
}

/* The Close Button */
.close {
    position: absolute;
    top: 20px;
    right: 35px;
    color: #111;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
    z-index: 99999;
}

.close:hover,
.close:focus {
    color: #111;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
    .modal-content {
        width: 100%;
    }
}

.gambar:hover {
    cursor: pointer;
    opacity: 0.5;
}
</style>